import styled from '@emotion/styled';
import { useLayoutHeaderContext } from '../../../modules/LayoutHeaderContext';

import LoggedInItems from './LoggedInItems';
import LoggedOutItems from './LoggedOutItems';

export default function GlobalNavItems() {
  const { user, isMemberLoading } = useLayoutHeaderContext();

  const isLoggedIn = user && user.id;

  // member 조회 중엔 로그인/로그아웃 판정을 유예(빈 슬롯) → 로그인 버튼 flash 방지. 확정되면 정답 렌더.
  return (
    <Container>
      {isMemberLoading ? null : isLoggedIn ? <LoggedInItems /> : <LoggedOutItems />}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
  height: 100%;
  align-items: center;
`;
